import type { SettingsColumn } from "./settings-back-link-placement"

const FULL_PAGES = [
	/^\/settings\/tags$/,
	/^\/settings\/integrations\/slack\/[^/]+\/channels$/,
]
const WIDE_PAGES = [/^\/settings\/plans\/pricing$/]
const EXTRA_WIDE_PAGES = [/^\/settings\/portal$/, /^\/settings\/portal\/theme$/]

export function settingsColumnFor(
	pathname: string | undefined,
): SettingsColumn {
	const path = pathname ?? ""
	if (FULL_PAGES.some((pattern) => pattern.test(path))) return "full"
	if (EXTRA_WIDE_PAGES.some((pattern) => pattern.test(path))) return "extraWide"
	if (WIDE_PAGES.some((pattern) => pattern.test(path))) return "wide"
	return "default"
}

// Selectable copy shows an I-beam that flips with the arrow around it, so the
// column keeps the arrow and only editors opt back into the text cursor.
export const SETTINGS_MAIN_CURSOR_CLASS =
	"cursor-default [&_.ProseMirror]:cursor-text"
